import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {useTranslation} from "react-i18next";
import NoData from "../../../components/no-data";
import InstrumentIcon from "../../../components/instrument-icon";
import FormButton from "../../../components/form-button";
import Big from "big.js";

const CampaignFunds = (props) => {
    const [loading, setLoading] = useState(true)
    const [fetching, setFetching] = useState(false)
    const [data, setData] = useState([])

    const {t} = useTranslation()

    useEffect(() => {
        getCampaignsFunds()
    }, [])

    const getCampaignsFunds = () => {
        setLoading(true)
        associateServices.getCampaignsFunds({}).then(res => {
            setData(res?.data || [])
            setLoading(false)
        })
    }

    const handleClaim = () => {
        setFetching(true)
        associateServices.claimCampaignsFunds({}).then(res => {
            getCampaignsFunds()
            setFetching(false)
        })
    }


    return (
        <div className="tab-pane fade show active">


            <div className="tab-content">
                {
                    loading ? <Loading/> :
                        <div className="tab-pane fade show active">
                            <div className="table-responsive">
                                {
                                    data?.length <= 0 ? <NoData desc={t('affiliate.campaigns.empty-fund')}/> :
                                        <>
                                            <table className="xtable xtable--small">
                                                <thead>
                                                <tr>
                                                    <th>{t('affiliate.funds.currency')}</th>
                                                    <th>{t('affiliate.funds.amount')}</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {
                                                    data?.map(debit => (
                                                        <tr key={debit?.id}>
                                                            <td>
                                                                <div className="xtable__text">
                                                                    <InstrumentIcon code={debit?.currency}/>
                                                                    {debit?.currency}
                                                                </div>
                                                            </td>


                                                            <td className="cursor-pointer">
                                                                <div
                                                                    className="xtable__text xtable__text--green">
                                                                    {Big(debit?.amount || 0).toFixed(8)}
                                                                </div>
                                                            </td>


                                                        </tr>
                                                    ))
                                                }

                                                </tbody>
                                            </table>
                                            <div
                                                className="row col-12 d-flex align-items-center justify-content-center mt-4">
                                                <FormButton
                                                    onClick={handleClaim}
                                                    isSmall={true}
                                                    loading={loading || fetching}
                                                    disabled={false}
                                                    label={t('affiliate.funds.claim')}
                                                />
                                            </div>
                                        </>

                                }
                            </div>

                        </div>
                }
            </div>


        </div>
    )
}

export default CampaignFunds
